"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var d3_format_1 = require("d3-format");

var d3_selection_1 = require("d3-selection");

var glamor_1 = require("glamor");

var glamor_tachyons_1 = require("glamor-tachyons");

var render_utils_1 = require("./render_utils");

function table(container, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (data && data.headers == null) {
    throw new Error('Data to render must have a "headers" property');
  }

  if (data && data.values == null) {
    throw new Error('Data to render must have a "values" property');
  }

  var drawArea = render_utils_1.getDrawArea(container);
  var options = Object.assign({}, defaultOpts, opts);
  var table = d3_selection_1.select(drawArea).select('table.tf-table');
  var tableStyle = glamor_1.css(Object.assign({}, glamor_tachyons_1.tachyons('f6 w-100 mw8 center'), {
    fontSize: options.fontSize
  }));

  if (table.size() === 0) {
    table = d3_selection_1.select(drawArea).append('table');
    table.attr('class', " ".concat(tableStyle, " tf-table"));
    table.append('thead').append('tr');
    table.append('tbody');
  }

  if (table.size() !== 1) {
    throw new Error('Error inserting table');
  }

  var headerRowStyle = glamor_1.css(Object.assign({}, glamor_tachyons_1.tachyons('fw6 bb b--black-20 tl pb3 pr3 bg-white')));
  var headers = table.select('thead').select('tr').selectAll('th').data(data.headers);
  var headersEnter = headers.enter().append('th').attr('class', "".concat(headerRowStyle));
  headers.merge(headersEnter).html(function (d) {
    return d;
  });
  headers.exit().remove();
  var format = d3_format_1.format(',.4~f');
  var rows = table.select('tbody').selectAll('tr').data(data.values);
  var rowsEnter = rows.enter().append('tr');
  var cellStyle = glamor_1.css(Object.assign({}, glamor_tachyons_1.tachyons('pa1 bb b--black-20')));
  var cells = rows.merge(rowsEnter).selectAll('td').data(function (d) {
    return d;
  });
  var cellsEnter = cells.enter().append('td').attr('class', "".concat(cellStyle));
  cells.merge(cellsEnter).html(function (d) {
    return typeof d === 'number' ? format(d) : d;
  });
  cells.exit().remove();
  rows.exit().remove();
}

exports.table = table;
var defaultOpts = {
  fontSize: 14
};